import { resetRouter } from '@/router'
import { PageEnum } from '@/enums/pageEnum'
// import allMenuList from './menu.json'
import { handleMenuData, setMenuIndexMapFn, getFirstRouteIndex, handleMenuItemForSys } from '@/utils/menu'

//把拥有权限的按钮过滤出来
function filterBtnsPerms(menus) {
  let list = []
  menus.forEach((item) => {
    if (item.type === 1) {
      list.push(item)
    }

    if (item.resources && item.resources.length) {
      list = [...list, ...filterBtnsPerms(item.resources)]
    }
  })
  return list
}

function getUserInfo() {
  let userInfo = localStorage.getItem('loginInfo')
  try {
    userInfo = JSON.parse(userInfo)
    return userInfo
  } catch (error) {
    return null
  }
}

const state = {
  userInfo: getUserInfo(),
  // lastUpdateTime: 0,
  btnPerms: [],
  menuList: [],
  homePage: PageEnum.BASE_HOME,
}

const getters = {
  getUserInfo: (state) => {
    return state.userInfo
  },

  getBtnPerms: (state) => {
    return state.btnPerms
  },

  getMenuList: (state) => {
    return state.menuList
  },

  getMenuIndexMap: (state) => {
    return setMenuIndexMapFn(state.menuList)
  },

  getHomePage: (state) => {
    return state.homePage
  },
}

const mutations = {
  SET_USER_INFO: (state, info = null) => {
    state.userInfo = info ? { ...info } : null
    if (info) {
      localStorage.setItem('loginInfo', JSON.stringify(info))
    } else {
      localStorage.removeItem('loginInfo')
    }
  },

  SET_BTN_PERMS: (state, list) => {
    state.btnPerms = [...list]
  },

  SET_MENU_LIST: (state, list) => {
    state.menuList = [...list]
  },

  SET_HOME_PAGE: (state, page) => {
    state.homePage = page
  },

  RESET_STATE(state) {
    state.menuList = []
    state.btnPerms = []
    state.userInfo = null
    state.homePage = PageEnum.BASE_HOME
    state.roleList = []
    resetRouter()
    localStorage.removeItem('loginInfo')
  },
}

const actions = {
  async getMenuListAction({ commit }, menus = []) {
    const menuList = handleMenuData(menus)
    console.log('---menuList---', menuList)

    const homeMenu = getFirstRouteIndex(menuList || [])
    const homePage = homeMenu.index

    commit('SET_MENU_LIST', menuList)
    commit('SET_HOME_PAGE', homePage)

    localStorage.setItem('indexPagePath', homePage)
  },

  async getUserInfoAction({ dispatch }) {
    // dispatch('getUserInfo');
    await dispatch('getMenuResourcesAction')
    dispatch('getPermAction')

    // await Promise.all([
    //   dispatch('getUserInfo'),
    //   dispatch('getMenuResourcesAction'),
    // ]);
    // try {
    // } catch (error) {
    //   commit('SET_USER_INFO', null);
    // }
  },

  async getMenuResourcesAction({ commit, dispatch }) {
    try {
      const menuRes = await dispatch('getMenutAction')
      if (!menuRes) {
        throw new Error('获取权限发生错误')
        // return
      }

      // const { menus = [], perms = [], user, session_key } = menuRes
      const menus = menuRes

      if (menus && menus.length) {
        const btnPerms = filterBtnsPerms(menus)
        commit('SET_BTN_PERMS', btnPerms)
        dispatch('getMenuListAction', menus)
      }
    } catch (error) {
      console.log(error)
    }
  },

  // async getMenutAction() {
  //   try {
  //     // const res = await API.httpGet('/resource/list')
  //     const res = await require('./menu.json')
  //     return res || null
  //   } catch (error) {
  //     return null
  //   }
  // },
  async getMenutAction() {
    try {
      const [err, data = []] = await window.Utils.awaitTo(window.API.httpPost('/permission/userMenu'))
      if (err) return null
      return handleMenuItemForSys(data)
    } catch (error) {
      return null
    }
  },

  async getPermAction({ commit }) {
    const [err, data = []] = await window.Utils.awaitTo(window.API.httpPost('/permission/userFuncType'))
    if (err) return

    // console.log(data);
    commit('SET_BTN_PERMS', data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
